// extracted by mini-css-extract-plugin
export var subtitle = "_bp-2";
export var title = "_bp-0";
export var titleNoWrap = "_bp-1";